import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Vue from 'vue'
import { CURRENT_ENV, Env, IS_PRIVATE } from '@/common/const/env'

const SENTRY_REPORT_ALL = 1
const SENTRY_REPORT_PRO = 0.02
/** 与 api-base-url 一致：仅 develop/test 视为日常环境，避免日语生产域名误判为 daily */
const isDaily = !IS_PRIVATE && CURRENT_ENV !== Env.release

if (!IS_PRIVATE) {
  Sentry.init({
    release: process.env.VERSION,
    environment: isDaily ? 'daily' : 'release',
    sampleRate: isDaily ? SENTRY_REPORT_ALL : SENTRY_REPORT_PRO,
    dsn: 'https://7669cfb414b94efe8d3f82791e6d5359@sentry.zhhainiao.com/193',
    defaultIntegrations: false,
    integrations: [
      new Integrations.Vue({
        Vue: Vue as any,
        attachProps: true,
      }),
    ],
  })
}
